module.exports = __webpack_public_path__ + "static/media/10PerformancePhotos.2c1a511b.jpeg";